// Where the person is, for VERA ("the drive from here", "weather where I am"). Off until they switch it on (Location
// on the field bar); then each question to VERA carries their device's position, read at most every two minutes.
// Nothing is tracked: the position goes only with a question, and only while it's on.

export type Here = { lat: number; lon: number; accuracy?: number; at: number };

const KEY = "vera-location-on";
let last: Here | null = null;

export function locationOn(): boolean {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

/** Switches it on (after the browser's own permission prompt) or off. Resolves false when the browser says no. */
export async function setLocationOn(on: boolean): Promise<boolean> {
  if (!on) {
    last = null;
    try { localStorage.removeItem(KEY); } catch { /* ignore */ }
    return true;
  }
  const here = await read(0);
  if (!here) return false;
  try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
  return true;
}

/** The position to send with a question, or undefined when Location is off or can't be read quickly. */
export async function currentLocation(): Promise<Here | undefined> {
  if (!locationOn()) return undefined;
  if (last && Date.now() - last.at < 120_000) return last;
  return (await read(120_000)) ?? last ?? undefined;
}

function read(maximumAge: number): Promise<Here | null> {
  if (typeof navigator === "undefined" || !navigator.geolocation) return Promise.resolve(null);
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (p) => { last = { lat: p.coords.latitude, lon: p.coords.longitude, accuracy: Math.round(p.coords.accuracy), at: Date.now() }; resolve(last); },
      () => resolve(null),
      { enableHighAccuracy: false, maximumAge, timeout: 6000 });
  });
}
